import "./topSearchbox.css";
import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes, faHistory } from "@fortawesome/free-solid-svg-icons";
import MobileSearch from "./mobileSearch";
import useSearchLogic   from "./searchLogic";
import { SEARCH_OPTIONS } from "../../data/registry";

const TopSearchBox = () => {
  const iconStyle: React.CSSProperties = {
    verticalAlign: "middle",
    marginRight:   10,
    fontSize:      13,
    color:        "#aaa",
  };

  const removeBtnStyle: React.CSSProperties = {
    verticalAlign: "middle",
    marginRight:   10,
    fontSize:      13,
    color:        "#555",
    border:        0,
    outline:      "none",
    background:  "transparent",
    float:       "right",
    padding:      10,
    cursor:     "pointer",
  };

  const {
    value, setValue,
    show, hide,
    open, activeIndex,
    clear, onKeyDown, search,
  } = useSearchLogic({ options: SEARCH_OPTIONS });

  const selectRef = useRef<HTMLDivElement>(null);
  const [hiddenOptions, setHiddenOptions] = useState<Set<string>>(new Set());

  const removeOption = (name: string) => {
    setHiddenOptions((prev) => new Set(prev).add(name));
  };

  return (
    <div>
      <MobileSearch />

      <div className="topmenu-search-box search-box">
        <div className="search-cont">

          <div className={`search${open ? " search-open" : ""}`}>
            <div className="search-value">
              <input
                placeholder=" "
                autoComplete="off"
                className="search-input"
                role="combobox"
                aria-expanded={open}
                aria-label="Search"
                aria-autocomplete="list"
                aria-controls="top-search-listbox"
                aria-activedescendant={activeIndex >= 0 ? `top-search-option-${activeIndex}` : undefined}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onFocus={show}
                onBlur={hide}
                onKeyDown={onKeyDown}
              />
            </div>

            <div
              className="search-select"
              ref={selectRef}
              style={{ display: open ? "block" : "none" }}
            >
              <div className="search-options" id="top-search-listbox" role="listbox">
                {SEARCH_OPTIONS.map((o, i) =>
                  hiddenOptions.has(o.name) ? null : (
                    <div
                      key={o.name}
                      id={`top-search-option-${i}`}
                      role="option"
                      aria-selected={i === activeIndex}
                      className={`topmenu-search-option search-option${i === activeIndex ? " search-option-active" : ""}`}
                    >
                      <span>
                        <FontAwesomeIcon className="fas" icon={faHistory} style={iconStyle} />
                        <a href={`/${o.value}`}>
                          {o.name}
                        </a>
                        <span>
                          <button
                            className="remove-btn"
                            style={removeBtnStyle}
                            onClick={() => removeOption(o.name)}
                          >
                            Remove
                          </button>
                        </span>
                      </span>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          <div className="searchbox-icons">
            <FontAwesomeIcon
              className="si fa-times clear-icon"
              icon={faTimes}
              title="Clear"
              onClick={clear}
            />
            <FontAwesomeIcon
              className="si fa-search-right"
              icon={faSearch}
              onClick={search}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSearchBox;
